import correctEndpointUrl from "../../constants/firebaseEndpoint";

export default async (organizationId, userId, groupId) => {
  const response = await fetch(`${correctEndpointUrl}/canUserAccessOrganizationOrGroup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    body: JSON.stringify({ organizationId, userId, groupId }),
  });

  return response.json();
};
